import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import { nftJsonState } from '../states/nftJsonState';
import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react';
import { LoadingModal } from './modal/loadingModalComponent';


import { UnWallet } from "unwallet-client-sdk";
import { WarningTwoIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

type Props = {
    buttonText: string,
}

//unWalletButton（TopShot用）
export const UnWalletButton: React.FC<Props> = (props) => {
    const nftJsonStatus = useRecoilValue(nftJsonState);
    const { isOpen:isOpenLM, onOpen:onOpenLM, onClose:onCloseLM } = useDisclosure();
    const { isOpen: isOpenM, onOpen: onOpenM, onClose: onCloseM } = useDisclosure();
    const nav = useNavigate();
    const [t, i18n] = useTranslation();
    const unWalletButtonStyle: React.CSSProperties = {
        boxSizing: 'border-box',
        height: '60px',
        border: '0.5px solid rgba(239, 239, 239, 0.2)',
        boxShadow: 'inset 0px 1px 0px rgba(255, 255, 255, 0.6)',
        marginBottom: '30px',
        borderRadius: '80px',
        transition: 'all 0.5s',
        backgroundColor:'rgba(55,134,155)',
        color: 'white',
        width: '254px',
        fontWeight: 'bold',
    };


    const unWalletConnect = async() =>{
        onOpenLM();
        sessionStorage.setItem('MetaForUnWallet',`${nftJsonStatus.nftmeta}`);

        const _clientID = (window.location.href.indexOf(`staging`) !== -1 || window.location.href.indexOf(`http://localhost`) !== -1)?`124575822059582`:`124563125963411`;
        const _redirectURL = (window.location.href.indexOf(`staging`) !== -1 || window.location.href.indexOf(`http://localhost`) !== -1)?`https://www.sushitop.io/13nftmaker/nftshot/staging/index.html`:`https://www.sushitop.io/13nftmaker/nftshot/index.html`; 
 
        const unWallet = await UnWallet.init({
            clientID:_clientID,
        });
        const nonceId = uuidv4();
        unWallet.authorize({
            redirectURL: _redirectURL,
            nonce: nonceId,
            isVirtual: true,
        });

    }

    return (
        <>
            <button 
                className='btn btn-primary btn-neumo' 
                style={unWalletButtonStyle} 
                id="btn-unwallet-getnft" 
                type="button" 
                onClick={()=> onOpenM()}
            >
                {props.buttonText}
            </button>
            
            {/* ローディング用モーダル */}
            <LoadingModal 
                isOpen={isOpenLM} 
                onClose={onCloseLM} 
            />



            {/* アラート用モーダル */}
            <Modal isCentered isOpen={isOpenM} onClose={onCloseM}>
                <ModalOverlay
                    backdropFilter='blur(15px)'
                />
                <ModalContent
                    bg={`tomato`}
                    w={`94%`}
                >
                <ModalHeader>
                    <HStack>
                    <WarningTwoIcon
                        boxSize={7}
                        color={`yellow`}
                    /> 
                    <Text
                        color={`white`}
                    >
                        {t('警告')}
                    </Text>
                    </HStack>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text
                        color={`white`}
                        fontWeight={`bold`}
                    >
                        {t('普段使用しているブラウザアプリ以外でこのサイトを開いている場合、正常に動作しない場合があります。')}<br/><br/>
                        {t('Safari , Chrome等のブラウザアプリから本サイトにアクセスし直してください')}<br/>
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button 
                        onClick={onCloseM} 
                        mr={`8px`}
                        id={`btn-default-browser-back`}
                    >
                        {t('戻る')}
                    </Button>

                    <Button 
                        onClick={unWalletConnect}
                        id={`btn-default-browser-go`}
                    >
                        {t('進む')}
                    </Button>
                </ModalFooter>
                </ModalContent>
            </Modal>  
        </>
    );
};